<template>
  <div id="app">
    <app-header />
    <app-top-nav-bar
      :key="`${rerenderKey}-1`"
      :is-authenticated="isUserLogged"
      @toggle-click="onHeaderToggleClick"
      :auth-user-name="loggedUserName"
      :auth-user-id="loggedUserId"
    />
    <app-side-nav-bar
      :key="`${rerenderKey}-2`"
      :toggle-triggered="sidebarToggleClicked"
      :logged-user-id="loggedUserId"
      :is-authenticated="isUserLogged"
      :is-admin="isUserAdmin"
      :is-super-admin="isSuperUserAdmin"
      :is-accounting="isUserAccountant"
      :is-owner="isUserOwner"
      :is-scc-user="isSccUser"
    />
    <div class="main-content" id="main-text">
      <div class="sidebar-content">
        <router-view />
      </div>
    </div>
    <app-footer />
    <scc-notifier ref="notifierRef" id="notifier" :toasts="notificationToasts" />
  </div>
</template>

<script>
import Vue from "vue";

import { ButtonPlugin, CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { SidebarPlugin } from "@syncfusion/ej2-vue-navigations";
import { enableRipple } from "@syncfusion/ej2-base";

import AppHeader from '@/components/app-header.vue';
import AppTopNavBar from '@/components/app-top-navbar.vue';
import AppSideNavBar from '@/components/app-side-navbar.vue';
import AppFooter from '@/components/app-footer.vue';
import SccNotifier from '@/components/base/scc-notifier.vue';
import { mapGetters } from 'vuex';
import browserEventsHandler from './shared/browser-events-handlers';

enableRipple(true);

Vue.use(ButtonPlugin);
Vue.use(TextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(TooltipPlugin);
Vue.use(SidebarPlugin);

export default {
  name: "App",
  components: {
    SccNotifier,
    AppHeader,
    AppTopNavBar,
    AppSideNavBar,
    AppFooter,
  },
  created() {
    browserEventsHandler.bindEvents();
  },
  data() {
    return {
      notificationToasts: [],
      sidebarToggleClicked: false,
      rerenderKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
    }),
    isUserLogged() {
      return this.loggedUser !== null;
    },
    isUserAdmin() {
      return this.isCurrentUserInRole("admin");
    },
    isSuperUserAdmin() {
      return this.isCurrentUserInRole("admin") || this.isCurrentUserInRole("superadmin");
    },

    isUserOwner() {
      return this.loggedUser ? this.loggedUser.isOwner : false;
    },
    isUserAccountant() {
      return this.isCurrentUserInRole("accounting");
    },
    loggedUserName() {
      return this.loggedUser?.name;
    },
    loggedUserId() {
      return this.loggedUser?.id;
    },
    isSccUser() {
      return this.loggedUser?.isSCCUser;
    },
  },
  methods: {
    onHeaderToggleClick() {
      this.sidebarToggleClicked = true;
      setTimeout(() => {
        this.sidebarToggleClicked = false;
      }, 100);
    },
    isCurrentUserInRole(roleName) {
      let roleIndex = -1;
      const currentUser = this.loggedUser;
      if (currentUser && currentUser.roles) {
        roleIndex = currentUser.roles.findIndex((r) => r.roleName.toLowerCase() === roleName);
      }
      return roleIndex >= 0;
    },
    forceRerender() {
      this.rerenderKey += 1;
    },
  },
};
</script>

<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-layouts/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-notifications/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";

@import "../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  margin: 0;
  font: 16px Sans-Serif;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
}
/* content area styles */

#main-text.main-content {
  height: calc(100% - 38px);
}

#main-text .sidebar-content .line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}

#main-text .sidebar-content {
  padding: 10px 10px 0px 25px;
  text-align: left;
  /* margin-right: 1ex !important; */
  /* margin-left: 19.3% !important; */
  height: 100%;
}
#content-with-boder {
  border-style: solid;
  border-width: 1px;
}

.stage-modal-position {
  top: 25% !important;
  /* left: 22% !important; */
}
/* end of content area styles */
</style>
